import fetchWithTimeout from "./fetchAPI";

/***
 * Send log messages to the server
 * @param {string} token
 * @param {array} logsQueue
 * @returns {Object}}
 */
export async function sendLogs(token, logsQueue) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
    const response = await fetchWithTimeout(
        `logs`,
        {
          method: "POST",
          cache: "no-cache",
          redirect: "follow",
          credentials: "omit",
          headers,
          body: JSON.stringify({
            'logs': logsQueue
          })
        },
        3000
      );
    
      return response.json();
}

/***
 * Get service worker token using session token
 * @param {string} token
 * @returns {string}
 */
export async function getSWtoken(token) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const response = await fetchWithTimeout(
    `session/serviceworker`,
    {
      method: "POST",
      cache: "no-cache",
      redirect: "follow",
      credentials: "omit",
      headers,
      body: JSON.stringify({
        'token': token
      })
    },
    3000
  );

  return response.json();
}
